import React, { useState } from 'react'
import { useScrollSpy } from '../hooks/useScrollSpy'
import { useI18n } from '../i18n/LanguageContext'
import LanguageSwitcher from './LanguageSwitcher'

const sectionIds = ['overview', 'explore', 'timeline', 'places', 'news', 'map', 'gallery']

function Header() {
  const { t } = useI18n()
  const [open, setOpen] = useState(false)
  const active = useScrollSpy(sectionIds)

  const navLinks = [
    { id: 'overview', label: t.nav.overview },
    { id: 'explore', label: t.nav.explore },
    { id: 'timeline', label: t.nav.history },
    { id: 'places', label: t.nav.places },
    { id: 'news', label: t.nav.news },
    { id: 'map', label: t.nav.map },
    { id: 'gallery', label: t.nav.gallery },
  ]

  return (
    <header className={`site-header${open ? ' is-menu-open' : ''}`}>
      <div className="progress" aria-hidden="true" />
      <div className="container header-inner">
        <a href="#top" className="brand" onClick={() => setOpen(false)}>
          <span className="brand-mark" aria-hidden="true" />
          <span>Nanovitsa</span>
          <span className="brand-bg" lang="bg">Нановица</span>
        </a>
        <div className="header-end">
          <nav id="site-nav" className={`site-nav${open ? ' is-open' : ''}`} aria-label="Main">
            <ul>
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className={active === link.id ? 'is-active' : undefined}
                    aria-current={active === link.id ? 'true' : undefined}
                    onClick={() => setOpen(false)}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <div className="header-actions">
            <LanguageSwitcher />
            <button
              type="button"
              className="menu-toggle"
              aria-expanded={open}
              aria-controls="site-nav"
              onClick={() => setOpen((value) => !value)}
            >
              <span className="menu-toggle-label">{open ? t.common.menuClose : t.common.menuOpen}</span>
              <span className="menu-toggle-icon" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
